var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotificationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M12 21c1.595 0 3-1.445 3-3h4c.843 0 1.078-.508.988-1.294a1.03 1.03 0 0 0-.2-.475L18 13l-.328-3.963S17.29 3 11.97 3 6.329 9.037 6.329 9.037L6 13l-1.843 3.278a1 1 0 0 0-.136.36C3.9 17.45 4.133 18 5.001 18H9c0 1.555 1.405 3 3 3Z"
})));
export default SvgNotificationIcon;